module.exports = __webpack_public_path__ + "img/eman.46604631.jpeg";